var map = {
	"./AuthorLayout": 1322,
	"./AuthorLayout.tsx": 1322,
	"./ListLayout": 5717,
	"./ListLayout.tsx": 5717,
	"./PostLayout": 3605,
	"./PostLayout.tsx": 3605,
	"./PostSimple": 291,
	"./PostSimple.tsx": 291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9618;